import kendo from "@progress/kendo-ui";

// 대상자목록, 대상자정보 데이터
export const getUserList = async (conn, data) => {
  const { userId, userTerm, rgnCode, dongCode, meainStatCode, bizType, dangerElderYn, isNotPlan } = data;
  const config = {
    params: {
      userId: userId,
      userTerm: userTerm,
      rgnCode: rgnCode,
      dongCode: dongCode,
      meainStatCode: meainStatCode,
      bizType: bizType,
      dangerElderYn: dangerElderYn,
      notPlan: isNotPlan,
    },
  };
  const response = await conn.get('/monitor/userStat/user/list', config);
  return response;
};

// 대상자 정보 페이지 이동 시 대상자 정보 데이터
export const getUserInfo = async (conn, userId) => {
  const config = {
    params: {
      userId: userId,
    },
  };
  const response = await conn.get('/monitor/userStat/user/info', config);
  return response;
}

// 모니터링상세정보 데이터
export const getData = async (conn, callback, reject, data) => {

  let startDtm = kendo.toString(data.startDtm, 'yyyy-MM-dd');
  let endDtm = kendo.toString(data.endDtm, 'yyyy-MM-dd');

  await conn.get('/data/raw/list', {
    params : {
      dateType: data.dateType,
      dataType: data.dataType,
      cid: data.cid,
      startDtm: startDtm,
      endDtm: endDtm
    }
  }).then((result) => {
    console.log("불러온 데이터 결과 = ", result);
    let movementData = [];
    let temperatureData = [];
    let humidityData = [];
    let co2Data = [];
    let lightData = [];
    let velocityTotalData = [];
    if(data.dateType === "HH") {
      result.forEach((element) => {
          movementData.push({ name: element.hour + "시", y: element.movement })
          temperatureData.push({ name: element.hour + "시", y: element.temperature })
          humidityData.push({ name: element.hour + "시", y: element.humidity })
          co2Data.push({ name: element.hour + "시", y: element.co2 })
          lightData.push({ name: element.hour + "시", y: element.light })
          velocityTotalData.push({ name: element.hour + "시", y: element.velocityTotal })
        });
    } else if(data.dateType === "DD") {
      result.forEach((element) => {
        movementData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.movement })
        temperatureData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.temperature })
        humidityData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.humidity })
        co2Data.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.co2 })
        lightData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.light })
        velocityTotalData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.velocityTotal })
      });
    } else if (data.dateType === "MM") {
      result.forEach((element) => {
        movementData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.movement })
        temperatureData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.temperature })
        humidityData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.humidity })
        co2Data.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.co2 })
        lightData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.light })
        velocityTotalData.push({ name: kendo.toString(new Date(element.date),"MM월dd일"), y: element.velocityTotal })
      });
    } else {

    }
      
    const resultData = {
      data: result,
      movement: movementData,
      temperature: temperatureData,
      humidity: humidityData,
      co2: co2Data,
      light: lightData,
      velocityTotal: velocityTotalData,
    }

    console.log("가공한 데이터 결과 = ", resultData);
    callback(resultData);
  })
  .catch((error) => {
    reject(error);
  });
}

// 대상자 장기부재 전환
export const setAbsenceYn = async (conn, data) => {
  const { userId, absenceYn } = data;
  const params = {
    userId: userId,
    absenceYn: absenceYn,
  };
  const response = conn.post('/elder/absenceYn', params);

  return response;
};

// 대상자 위험대상자 전환
export const setDangerYn = async (conn, data) => {
  const { userId, dangerYn } = data;
  const params = {
    userId: userId,
    dangerYn: dangerYn,
  };
  const response = conn.post('/elder/dangerYn', params);

  return response;
};

// 설치예정 대상자로 전환
export const setInstallPlan = async (conn, data) => {
  const { userId, meainStatCode } = data;
  const params = {
    userId: userId,
    meainStatCode: meainStatCode,
  };
  const response = conn.post('/elder/installPlan', params);

  return response;
}